import { API } from '../config';

const UnAuthenticated = (): JSX.Element => {
  window.location.replace(`${API}/connect/install`);
  return <></>;
};

export default UnAuthenticated;
